// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2m3D0","emails":"CreateEditClinics_emails__1ZYvI","emailTagLabel":"CreateEditClinics_emailTagLabel__27wEr"};